import { callAPI, NOTIFY_ADMINS_ENDPOINT } from "./callAPI";

// mirror on server
export const SENDINBLUE_CONSTANTS = {
  events: {
    jobSubmitted: "JOB_SUBMITTED",
    jobResubmitted: "JOB_RESUBMITTED",
    clfSubmitted: "CLF_SUBMITTED",
    companyProfileSubmitted: "COMPANY_PROFILE_SUBMITTED",
    companyProfileResubmitted: "COMPANY_PROFILE_RESUBMITTED",
  },
};

export async function notifyAdmins({ event, params }) {
  try {
    await callAPI({
      endpoint: NOTIFY_ADMINS_ENDPOINT,
      opts: {
        body: {
          event,
          params,
        },
      },
    });
  } catch (e) {
    console.log(e);
  }
}
